const getters = {
  sceneId: state => state.map.sceneId,
  hlookat: state => state.map.hlookat,
  mapUrl: state => state.map.mapUrl,
  mapList: state => state.map.mapList,
}
export default getters
